/**
 * Which of the four list screens the automations dialog shows. One value both
 * the header and the body read, so "the empty state owns the first create
 * button" cannot drift into two of them or none.
 */
export type AutomationsListState = 'loading' | 'rules' | 'error' | 'empty';

interface ListStateInput {
  isLoading: boolean;
  isError: boolean;
  ruleCount: number;
}

/**
 * Rules outrank the error: a query keeps its last good data when a refetch
 * fails, and the refetch that follows a delete is the likeliest one to fail, so
 * reading the error first would blank out the very list being edited. A failed
 * FIRST fetch is still its own screen, since the data falls back to an empty
 * list and folding that into `empty` would invite someone to recreate rules
 * they already have.
 */
export function automationsListState({
  isLoading,
  isError,
  ruleCount,
}: ListStateInput): AutomationsListState {
  if (isLoading) return 'loading';
  if (ruleCount > 0) return 'rules';
  return isError ? 'error' : 'empty';
}
